module.exports = __webpack_public_path__ + "static/media/logo-tickets-levo-dark.d3156d07.png";